/**
 * CancelButton — D-UI-CANCEL-01.
 *
 * Visible solo cuando sseState in {classifying, searching, thinking, middleware_block}.
 * Tap → useChatStore.cancel() → AbortController.abort() → backend recibe disconnect.
 *
 * Tap target ≥44×44.
 */
import { useChatStore } from '../store/chat'

export function CancelButton() {
  const sseState = useChatStore((s) => s.sseState)
  const cancel = useChatStore((s) => s.cancel)

  const visible =
    sseState.status === 'classifying' ||
    sseState.status === 'searching' ||
    sseState.status === 'thinking' ||
    sseState.status === 'middleware_block'

  if (!visible) return null

  return (
    <button
      type="button"
      aria-label="Cancelar consulta"
      onClick={cancel}
      className="text-[13px] font-medium transition-colors"
      style={{
        minHeight: 44,
        minWidth: 44,
        padding: '8px 16px',
        borderRadius: 999,
        border: '1px solid var(--color-border-strong)',
        background: 'var(--color-surface)',
        color: 'var(--color-text-muted)',
        cursor: 'pointer',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = 'var(--color-danger)'
        e.currentTarget.style.color = 'var(--color-danger)'
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = 'var(--color-border-strong)'
        e.currentTarget.style.color = 'var(--color-text-muted)'
      }}
    >
      Cancelar
    </button>
  )
}
